import { render, staticRenderFns } from "./a.vue?vue&type=template&id=181822c7&scoped=true&"
import script from "./a.vue?vue&type=script&lang=js&"
export * from "./a.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181822c7",
  null
  
)

component.options.__file = "a.vue"
export default component.exports